"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToBoolean = stringToBoolean;
function stringToBoolean(input) {
    return input === 'false' || !input ? false : true;
}
//# sourceMappingURL=boolean.util.js.map